import { createContext, useContext, useState } from 'react'

import type { ReactNode } from 'react'

import type { EmployeeProxyOrderResponse } from '@/api/@types'

type OrderNoContextValue = {
  orderNo: string
  setOrderNo: (value: string) => void
  employeeOrderResult: EmployeeProxyOrderResponse | null
  setEmployeeOrderResult: (value: EmployeeProxyOrderResponse | null) => void
}

const OrderNoContext = createContext<OrderNoContextValue>({
  orderNo: '',
  setOrderNo: () => {},
  employeeOrderResult: null,
  setEmployeeOrderResult: () => {},
})

export const OrderNoProvider = ({
  children,
  defaultValue = '',
}: {
  children: ReactNode
  defaultValue?: string
}) => {
  const [orderNo, setOrderNo] = useState(defaultValue)
  const [employeeOrderResult, setEmployeeOrderResult] =
    useState<EmployeeProxyOrderResponse | null>(null)

  return (
    <OrderNoContext.Provider
      value={{
        orderNo,
        setOrderNo,
        employeeOrderResult,
        setEmployeeOrderResult,
      }}
    >
      {children}
    </OrderNoContext.Provider>
  )
}

export const useOrderNo = () => {
  return useContext(OrderNoContext)
}
